import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

enum SocketIoEventName {
  JOIN_ROOM = 'joinRoom',
  LEAVE_ROOM = 'leaveRoom',
}

@Injectable({
  providedIn: 'root',
})
export class SocketIoService {
  private socket!: Socket;
  #http = inject(HttpClient);
  #isBrowser: boolean = false;
  // isPlatformBrowser(inject(PLATFORM_ID));

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    if (isPlatformBrowser(platformId)) {
      this.#isBrowser = true;
      this.#initialize();
    }
  }

  #initialize() {
    // const scopeContext = window.localStorage.getItem(AUTH_SCOPE_CONTEXT_KEY);
    // if (!scopeContext) {
    //   console.warn('MISSING SCOPE_CONTEXT');
    //   return;
    // }
    if (this.socket) {
      console.debug('socket already setup');
      return;
    }
    this.socket = io(`${environment.socketIoUrl}/application`, {
      auth: {
        token: `Basic ${environment.socketAuth}`,
      },
      transports: ['websocket'],
    });

    // Optional: Error handling
    this.socket.on('connect_error', (err) => {
      console.error('Socket.IO connect_error:', err);
      throw err;
    });
  }

  listen<T>(eventName: string): Observable<T | null> {
    if (!this.#isBrowser) {
      return of(null);
    }
    if (!this.socket) {
      this.#initialize();
    }
    const newMessageEvent = 'newMessage';
    return new Observable<T>((sub) => {
      this.socket.on(newMessageEvent, (data: T) => sub.next(data));
      return () => this.socket.off(newMessageEvent);
    });
  }

  #emit(eventName: string, data?: any): void {
    if (!this.#isBrowser) {
      return;
    }
    if (!this.socket) {
      this.#initialize();
    }
    this.socket.emit(eventName, data);
  }

  joinRoom(chatId: string) {
    this.#emit(SocketIoEventName.JOIN_ROOM, { room: chatId });
  }

  leaveRoom(chatId: string) {
    this.#emit(SocketIoEventName.LEAVE_ROOM, { room: chatId });
  }

  #disconnect(): void {
    if (!this.#isBrowser) {
      return;
    }
    this.socket.disconnect();
  }

  isHealthy() {
    return this.#http.get<void>(`${environment.socketIoUrl}/health-check`);
  }
}
